import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { forwardRef, memo, useId, Children, isValidElement, cloneElement } from 'react';
import CompaniesLogosWrapper from '../wrappers/CompanyLogosWrapper';
import CompaniesMonoLogosWrapper from '../wrappers/CompanyMonoLogosWrapper';
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var wrapperComponents = {
  Company: CompaniesLogosWrapper,
  CompanyMono: CompaniesMonoLogosWrapper
};
var urlIdRegex = /url\(#(.*)\)/;
var possibleUrlProps = ["href", "fill", "stroke", "filter", "clip-path", "mask", "marker-start", "marker-mid", "marker-end"];
/**
 * This function is used to recursively replace the id prop of the children of the SVG element.
 * It also updates any references to the old id like `url(#some-id)`.
 * This is necessary because the SVG element can be used multiple times on the same page
 * resulting in multiple elements with the same id.
 *
 * NOTE: This is a recursive function and it might result in a stack overflow if the SVG element is too deep.
 */

var recursivelySufixIdProp = function recursivelySufixIdProp(path, id) {
  if (! /*#__PURE__*/isValidElement(path)) {
    return path;
  }

  var uniqueIdProps = Object.fromEntries(Object.entries(path.props).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    return ["id", "children"].concat(possibleUrlProps).includes(key);
  }));

  if (uniqueIdProps.id) {
    uniqueIdProps.id = "".concat(uniqueIdProps.id, "-").concat(id);
  }

  var _iterator = _createForOfIteratorHelper(possibleUrlProps),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var prop = _step.value;
      var propValue = uniqueIdProps[prop];

      if (typeof propValue === "string" && propValue.match(urlIdRegex)) {
        // Add suffix to the id reference
        uniqueIdProps[prop] = propValue.replace(urlIdRegex, "url(#$1-".concat(id, ")"));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (uniqueIdProps.children) {
    // Recursively update the children
    uniqueIdProps.children = Children.map(uniqueIdProps.children, function (child) {
      return recursivelySufixIdProp(child, id);
    });
  }

  return /*#__PURE__*/cloneElement(path, uniqueIdProps);
};

var createSvgComponent = function createSvgComponent(path, displayName, type) {
  var Wrapper = wrapperComponents[type];

  var Component = function Component(_ref3, ref) {
    var children = _ref3.children,
        rest = _objectWithoutProperties(_ref3, _excluded);

    var id = useId();
    return _jsxs(Wrapper, _objectSpread(_objectSpread({
      ref: ref,
      "aria-hidden": "true",
      "data-testid": "customerLogos[".concat(displayName, "]")
    }, rest), {}, {
      children: [recursivelySufixIdProp(path, id), children]
    }));
  };

  if (false) {
    Component.displayName = displayName;
  }

  return /*#__PURE__*/memo( /*#__PURE__*/forwardRef(Component));
};

export default createSvgComponent;